module.exports = __webpack_public_path__ + "media/images/clients/baokim-00b8ade2bd0c637c79630ab4f51dcfc8.png";